
import {
  SAVE_CLIENT_DIAGNOSIS,
} from '../actions/types';

const initialState = {
  diagnosisList: [],
};

export const DiagnosisReducer = (state = initialState, action: any) => {
  const oldState = { ...state };
  const { type, payload } = action;
  switch (action.type) {
    case SAVE_CLIENT_DIAGNOSIS:
      return {
        ...state,
        diagnosisList: payload,
      };

    default:
      return { ...state };
  }
};
